module.exports = __webpack_public_path__ + "img/folder-icon.a2ba9caa.png";